import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Firebase/AuthProvider";
import "./homeLanding.css";

const BISMILLAH_BUTTON =
    "\u0628\u0650\u0633\u0652\u0645\u0650 \u0671\u0644\u0644\u0651\u064e\u0670\u0647\u0650 \u0671\u0644\u0631\u064e\u062D\u064e\u0645\u064e\u0670\u0646\u0650 \u0671\u0644\u0631\u064e\u062D\u0650\u064A\u0645\u0650";

const QUOTES = [
    {
        urdu: "اور انسان کے لیے وہی کچھ ہے جس کی اس نے کوشش کی۔",
        eng: "And that there is not for man except that [good] for which he strives.",
        src: "Qur'an (53:39)",
    },
    {
        urdu: "اللہ صبر کرنے والوں کے ساتھ ہے۔",
        eng: "Indeed, Allah is with the patient.",
        src: "Qur'an (2:153)",
    },
    {
        urdu: "جو شخص محنت کرتا ہے، اللہ اس کے رزق میں برکت ڈالتا ہے۔",
        eng: "Barakah is attached to honest, disciplined work.",
        src: "Islamic Principle",
    },
];

function Dashboard() {
    const { user, running, UserLogin } = useContext(AuthContext);
    const navigate = useNavigate();

    const [quoteIndex, setQuoteIndex] = useState(0);
    const [revealKey, setRevealKey] = useState(0);
    const [welcomeExit, setWelcomeExit] = useState(false);
    const [flashOn, setFlashOn] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [loginBusy, setLoginBusy] = useState(false);
    const [loginError, setLoginError] = useState(null);

    const emailRef = useRef(null);
    const passRef = useRef(null);

    const q = QUOTES[quoteIndex];

    const bumpQuote = useCallback(() => {
        setQuoteIndex((i) => (i + 1) % QUOTES.length);
        setRevealKey((k) => k + 1);
    }, []);

    useEffect(() => {
        const t = setInterval(bumpQuote, 8000);
        return () => clearInterval(t);
    }, [bumpQuote]);

    useEffect(() => {
        if (!loginOpen) return;
        const onKey = (e) => {
            if (e.key === "Escape") setLoginOpen(false);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [loginOpen]);

    const goAdmin = () => {
        navigate("/admin/0");
    };

    const handleEnter = () => {
        if (running) return;
        if (user) {
            setFlashOn(true);
            setWelcomeExit(true);
            window.setTimeout(() => {
                setFlashOn(false);
                goAdmin();
            }, 700);
        } else {
            setLoginError(null);
            setLoginOpen(true);
        }
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        setLoginError(null);
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const email = (emailRef.current?.value || "").trim();
        const password = passRef.current?.value || "";
        if (!email || !emailPattern.test(email) || !password) {
            setLoginError("Valid email and password are required.");
            return;
        }
        setLoginBusy(true);
        try {
            await UserLogin(email, password);
            setLoginOpen(false);
            setFlashOn(true);
            setWelcomeExit(true);
            window.setTimeout(() => {
                setFlashOn(false);
                goAdmin();
            }, 500);
        } catch {
            setLoginError("Invalid credentials.");
        } finally {
            setLoginBusy(false);
        }
    };

    return (
        <div className="mavi-home">
            <div className={`mavi-home__flash ${flashOn ? "mavi-home__flash--on" : ""}`} aria-hidden="true" />

            <div className={`mavi-home__welcome ${welcomeExit ? "mavi-home__welcome--exit" : ""}`}>
                <div className="mavi-home__ambient mavi-home__ambient--green" aria-hidden="true" />
                <div className="mavi-home__ambient mavi-home__ambient--gold" aria-hidden="true" />
                <div className="mavi-home__dots" aria-hidden="true" />

                <div className="mavi-home__watermark" aria-hidden="true">
                    <h1>اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ</h1>
                </div>

                <div className="mavi-home__inner">
                    <div className="mavi-home__quote-wrap">
                        <div className="mavi-home__quote-box" key={revealKey}>
                            <p
                                className="mavi-home__quote-urdu mavi-home__cinematic mavi-home__cinematic--delay-1 mavi-home__cinematic--active"
                            >
                                {q.urdu}
                            </p>
                            <p
                                className="mavi-home__quote-eng mavi-home__cinematic mavi-home__cinematic--delay-2 mavi-home__cinematic--active"
                            >
                                {q.eng}
                            </p>
                            <div className="mavi-home__quote-src mavi-home__cinematic mavi-home__cinematic--delay-3 mavi-home__cinematic--active">
                                <span className="mavi-home__quote-src-line" />
                                <p>{q.src}</p>
                                <span className="mavi-home__quote-src-line" />
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="mavi-home__btn"
                        onClick={handleEnter}
                        disabled={running}
                        aria-label={user ? "Enter admin panel" : "Sign in to enter admin panel"}
                    >
                        <span className="mavi-home__text-gold-foil">{BISMILLAH_BUTTON}</span>
                    </button>
                </div>
            </div>

            {loginOpen && (
                <div
                    className="mavi-home-modal-backdrop"
                    role="presentation"
                    onClick={() => !loginBusy && setLoginOpen(false)}
                >
                    <div
                        className="mavi-home-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="mavi-home-login-title"
                        onClick={(ev) => ev.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="mavi-home-modal__close"
                            onClick={() => !loginBusy && setLoginOpen(false)}
                            aria-label="Close"
                        >
                            ×
                        </button>
                        <h2 id="mavi-home-login-title" className="mavi-home-modal__title">
                            Admin access
                        </h2>
                        <p className="mavi-home-modal__sub">Sign in with your MAVIINCI credentials.</p>
                        <form onSubmit={handleLoginSubmit}>
                            <label className="mavi-home-modal__label" htmlFor="mavi-home-email">
                                Email
                            </label>
                            <input
                                id="mavi-home-email"
                                ref={emailRef}
                                className="mavi-home-modal__input"
                                type="email"
                                autoComplete="username"
                                placeholder="you@example.com"
                                disabled={loginBusy}
                            />
                            <label className="mavi-home-modal__label" htmlFor="mavi-home-pass">
                                Password
                            </label>
                            <input
                                id="mavi-home-pass"
                                ref={passRef}
                                className="mavi-home-modal__input"
                                type="password"
                                autoComplete="current-password"
                                placeholder="••••••••"
                                disabled={loginBusy}
                            />
                            {loginError ? <p className="mavi-home-modal__error">{loginError}</p> : null}
                            <button type="submit" className="mavi-home-modal__submit" disabled={loginBusy}>
                                {loginBusy ? "Signing in…" : "Login"}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Dashboard;
